(function () {
  'use strict';
  function scrollTarget(top, scrollY, headerHeight) {
    const clearance = headerHeight + 16;
    return top < clearance ? Math.max(0, scrollY + top - clearance) : null;
  }
  if (typeof module !== 'undefined') module.exports = { scrollTarget };
  if (typeof document === 'undefined') return;
  let timer;
  function cancel() { clearTimeout(timer); }
  function headerHeight() {
    const main = document.querySelector('#main-header');
    const product = document.querySelector('#mobile-sticky-product-header');
    // The main header may reappear when scrolling upward: reserve its full height.
    let height = main && main.getClientRects().length ? main.offsetHeight : 0;
    if (product && product.getClientRects().length && product.classList.contains('visible')) {
      height += product.offsetHeight;
    }
    return height;
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.pn-product-accordion__trigger');
    if (!trigger) return;
    cancel();
    // Let Alpine update state and both opening/closing 300ms grid transitions finish.
    timer = setTimeout(() => {
      if (!trigger.isConnected || trigger.getAttribute('aria-expanded') !== 'true' ||
          !trigger.getClientRects().length) return;
      const top = scrollTarget(trigger.getBoundingClientRect().top, window.scrollY, headerHeight());
      if (top !== null) window.scrollTo({ top,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 360);
  });
  // Do not pull the reader back after they start a new gesture while panels animate.
  for (const event of ['pointerdown', 'touchstart', 'wheel', 'keydown', 'pagehide']) {
    window.addEventListener(event, cancel, { passive: true });
  }
})();
